import Comp, { Frame1, Frame2, Frame3, HotImage } from "./comp";
import Desc from "./desc";
import Preview from "./preview";

const Plugin = {
  name: "特殊滑屏",
  render: Comp,
  board: Desc,
  preview: Preview,
  subPlugins: [Frame1, Frame2, Frame3, HotImage],
  type: "SpecialSlide",
  props: {
    banners: [
      [
        {
          imageUrl:
            "//img30.360buyimg.com/zx/jfs/t1/100020/5/38609/44708/64096c1aF8ca20642/4e31ec08d9755c54.png",
          jumpUrl:
            "//img30.360buyimg.com/zx/jfs/t1/100020/5/38609/44708/64096c1aF8ca20642/4e31ec08d9755c54.png",
          hotImageUrl:
            "//img12.360buyimg.com/zx/jfs/t1/263854/29/27079/226252/67c515eeFc7e84ff6/dccabfea660b7280.png",
          hotArea: [],
        },
        {
          imageUrl:
            "//img30.360buyimg.com/zx/jfs/t1/100020/5/38609/44708/64096c1aF8ca20642/4e31ec08d9755c54.png",
          jumpUrl:
            "//img30.360buyimg.com/zx/jfs/t1/100020/5/38609/44708/64096c1aF8ca20642/4e31ec08d9755c54.png",
          hotImageUrl:
            "//img12.360buyimg.com/zx/jfs/t1/263854/29/27079/226252/67c515eeFc7e84ff6/dccabfea660b7280.png",
          hotArea: [],
        },
        {
          imageUrl:
            "//img12.360buyimg.com/zx/jfs/t1/208860/20/30225/43443/64096bf8Ff0a332ee/a9f2ea1685fd1607.png",
          jumpUrl:
            "//img30.360buyimg.com/zx/jfs/t1/100020/5/38609/44708/64096c1aF8ca20642/4e31ec08d9755c54.png",
          hotImageUrl:
            "//img12.360buyimg.com/zx/jfs/t1/263854/29/27079/226252/67c515eeFc7e84ff6/dccabfea660b7280.png",
          hotArea: [],
        },
      ],
    ],
    imgWidth: 200,
    imgHeight: 400,
    slideWidth: 375,
    shrinkScale: 0.8,
    opacity: 0.8,
    interval: 3,
    subProps: [
      {
        opacity: 1,
      },
      {
        opacity: 0.8,
      },
      {
        opacity: 0.7,
      },
    ],
  },
  extension: {
    intervalDuration: [1, 10],
    slideWidthDuration: [0, 375],
    bannersGroupStruct: [
      {
        imageUrl: "",
        jumpUrl: "",
      },
    ],
  },
  rectOptions: {
    width: 200,
    height: 200,
    left: 0,
    top: 0,
    rotate: 0,
    subRectOptions: [
      {
        width: 140,
        height: 140,
        left: 0,
        top: 80,
        rotate: 0,
      },
      {
        width: 80,
        height: 80,
        left: 20,
        top: 140,
        rotate: 0,
      },
      {
        width: 70,
        height: 70,
        left: 190,
        top: 290,
        rotate: 0,
      },
      {
        width: 375,
        height: 200,
        left: 0,
        top: 0,
        rotate: 0,
      },
    ],
  },
  drawOptions: {
    resize: true,
    drag: true,
    rotate: false,
    keepRatio: false,
    renderDirections: ["s"],
    subOptions: [
      {
        resize: true,
        drag: true,
        rotate: false,
        keepRatio: false,
        // renderDirections: ['n', 's']
      },
      {
        resize: true,
        drag: true,
        rotate: false,
        keepRatio: false,
        // renderDirections: ['n', 's']
      },
      {
        resize: true,
        drag: true,
        rotate: false,
        keepRatio: false,
        // renderDirections: ['n', 's']
      },
      {
        resize: true,
        drag: true,
        rotate: false,
        keepRatio: false,
        // renderDirections: ['n', 's']
      },
    ],
  },
};

export default Plugin;
